import { createSetAvatarOutbound } from '../../api/outbound/pokerOutbounds';
export const CLEAR_SELF_AVATAR_STATE = 'CLEAR_SELF_AVATAR_STATE';
export const INIT_NEW_AVATAR = 'INIT_NEW_AVATAR';
export const SET_SELF_AVATAR = 'SET_SELF_AVATAR';
export const CHANGE_SELF_AVATAR_PART_COLOR = 'CHANGE_SELF_AVATAR_PART_COLOR';
export const CANCEL_PENDING_AVATAR_CHANGES = 'CANCEL_PENDING_AVATAR_CHANGES';
export const UPDATE_AVATAR_FROM_PENDING = 'UPDATE_AVATAR_FROM_PENDING';
export const SET_AVATAR_PART_INDEX = 'SET_AVATAR_PART_INDEX';
export const SET_IS_AVATAR_EDITOR_OPEN = 'SET_IS_AVATAR_EDITOR_OPEN';
export const SET_PENDING_AVATAR = 'SET_PENDING_AVATAR';
export function clearSelfAvatarState() {
    return {
        type: CLEAR_SELF_AVATAR_STATE
    };
}
export function initNewAvatar() {
    return {
        type: INIT_NEW_AVATAR
    };
}
export function setSelfAvatar(playerAvatar) {
    return {
        type: SET_SELF_AVATAR,
        payload: playerAvatar
    };
}
export function changeSelfAvatarPartColor(colorType, color) {
    return {
        type: CHANGE_SELF_AVATAR_PART_COLOR,
        payload: { colorType, color }
    };
}
export function cancelPendingAvatarChanges() {
    return {
        type: CANCEL_PENDING_AVATAR_CHANGES
    };
}
function updateAvatarFromPending() {
    return {
        type: UPDATE_AVATAR_FROM_PENDING
    };
}
export const thunkSaveAvatar = (socketSend) => {
    return function (dispatch, getState) {
        const state = getState();
        if (state.selfAvatar.avatar && state.selfAvatar.avatar.pendingAvatar.type === 'custom') {
            socketSend(createSetAvatarOutbound(state.selfAvatar.avatar.pendingAvatar.avatar));
            dispatch(updateAvatarFromPending());
        }
    };
};
export function setAvatarPartIndex(partType, index, subType) {
    return {
        type: SET_AVATAR_PART_INDEX,
        payload: { partType, index, subType }
    };
}
export function setIsAvatarEditorOpen(isOpen) {
    return {
        type: SET_IS_AVATAR_EDITOR_OPEN,
        payload: isOpen
    };
}
export function setPendingAvatar(avatarPropertiesSet) {
    return {
        type: SET_PENDING_AVATAR,
        payload: avatarPropertiesSet
    };
}
